import 'flag-icons/css/flag-icons.min.css';

import { Router } from './router';

const App = () => <Router />;

export default App;
